import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import LiveQuizPage from './LiveQuizPage';
import InviteLink from '../InviteGuests';
import './livequizpage.css';

const QuizCaseDosages = () => {
  const userDetails = useSelector((state) => state.userDetails);
  const user = userDetails?.user;
  const [showShareMessage, setShowShareMessage] = useState(false);

  // Derive the room number from user id
  const roomNumber = user ? user.id * 35 : null;

  // Function to handle sharing
  const handleShare = () => {
    const url = `http://andrewslearning.com/joinquiz/122/${roomNumber}/`;
    navigator.clipboard.writeText(url);
    setShowShareMessage(true);
    setTimeout(() => setShowShareMessage(false), 3000);
  };

  if (!user) {
    return (
      <div className="outer-quiz-container">
        <div className="message">
          <h3>Error: User must be logged in to host a quiz!</h3>
          <p>Please sign in to continue.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="outer-quiz-container">
      <div className="game-intro-section">
        <div className="intro-header">
          <h1>Pharmaceutical Dosage Calculations</h1>
          <div className="intro-tagline">Test your knowledge of medication dosages, concentrations, and clinical calculations</div>
          <div className="share-controls">
            <button 
              className="share-button" 
              onClick={handleShare}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                padding: '10px 15px',
                backgroundColor: '#3498db',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                fontWeight: 'bold',
                cursor: 'pointer',
                marginTop: '10px',
                transition: 'all 0.2s ease'
              }}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 8C19.6569 8 21 6.65685 21 5C21 3.34315 19.6569 2 18 2C16.3431 2 15 3.34315 15 5C15 6.65685 16.3431 8 18 8Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M6 15C7.65685 15 9 13.6569 9 12C9 10.3431 7.65685 9 6 9C4.34315 9 3 10.3431 3 12C3 13.6569 4.34315 15 6 15Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M18 22C19.6569 22 21 20.6569 21 19C21 17.3431 19.6569 16 18 16C16.3431 16 15 17.3431 15 19C15 20.6569 16.3431 22 18 22Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M8.59 13.51L15.42 17.49" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M15.41 6.51L8.59 10.49" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Share Quiz
            </button>
            {showShareMessage && (
              <div 
                className="share-message"
                style={{
                  backgroundColor: '#2ecc71',
                  color: 'white',
                  padding: '10px 15px',
                  borderRadius: '5px',
                  marginTop: '10px',
                  fontWeight: 'bold',
                  animation: 'fadeIn 0.3s ease-in-out'
                }}
              >
                Quiz link copied to clipboard!
              </div>
            )}
          </div>
        </div>
        
        <div className="intro-card">
          <div className="intro-card-header">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#3498db" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 8V12" stroke="#3498db" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <circle cx="12" cy="16" r="1" fill="#3498db"/>
            </svg>
            <h2>How to Play</h2>
          </div>
          
          <div className="intro-card-content">
            <p>Welcome to the Dosage Calculations Quiz! Test your ability to calculate medication dosages, conversions, and concentrations in a challenging, interactive format.</p>
            
            <div className="intro-steps">
              <div className="step">
                <div className="step-number">1</div>
                <div className="step-text">The host starts the game focused on pharmaceutical dosage calculations.</div>
              </div>
              
              <div className="step">
                <div className="step-number">2</div>
                <div className="step-text">Participants will join the game using a unique room code provided by the host.</div>
              </div>
              
              <div className="step">
                <div className="step-number">3</div>
                <div className="step-text">Each question will present a clinical scenario requiring accurate medication dosage calculations.</div>
              </div>
              
              <div className="step">
                <div className="step-number">4</div>
                <div className="step-text">Points are awarded based on accuracy and speed. The faster you answer correctly, the more points you earn!</div>
              </div>
              
              <div className="step">
                <div className="step-number">5</div>
                <div className="step-text">At the end of the game, the player with the highest score wins!</div>
              </div>
            </div>
            
            <div className="intro-card-footer">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 2V5" stroke="#e74c3c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M16 2V5" stroke="#e74c3c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M3 8H21" stroke="#e74c3c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M19 4H5C3.89543 4 3 4.89543 3 6V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V6C21 4.89543 20.1046 4 19 4Z" stroke="#e74c3c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 12H15V15" stroke="#e74c3c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M9 14L12 17" stroke="#e74c3c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 17L15 14" stroke="#e74c3c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <p>Good luck, and may the most precise clinician win!</p>
            </div>
          </div>
        </div>
        
        <div className="invite-section">
          <h3>Invite Players</h3>
          <p>Share the room code with other participants to join this quiz session</p>
          <InviteLink roomNumber={roomNumber} topics={[122]} />
        </div>
      </div>
      
      <div className="game-container">
        <LiveQuizPage topics={122} roomNumber={roomNumber} />
      </div>
    </div>
  );
};

export default QuizCaseDosages;
